import { render } from "./bannerPopup.vue?vue&type=template&id=3cc1759c&ts=true"
import script from "./bannerPopup.vue?vue&type=script&lang=ts&config=true"
export * from "./bannerPopup.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__